import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ck-ui';
import { PopupModalContent } from './PopupModalContent';

const PopupSignUp = ({
  campaignId,
  giftImage,
  popupHeading,
  popupContent,
  popupHero,
  secsToPopup,
  daysNotToShow,
  closedCountMax,
  isForReturnedUser,
}) => {
  const [show, setShow] = useState(false);
  const [hasSignedUp, setHasSignedUp] = useState(false);
  const prefix = campaignId || '';
  const isReturnedUser = localStorage.getItem('smsPopupSignedUp') === 'true';

  useEffect(() => {
    // if there is a modal currently active, do not show
    if (document.querySelector('.modal.is-active:not(.mfp-initiated)')) return;
    // if user close the popup, don't show it until next week's promo
    if (localStorage.getItem(`${prefix}SignUpClosed`) === 'true') return;
    // if the user has signedUp this week's promo in this device, don't show the popup
    if (localStorage.getItem(`${prefix}SignedUp`) === 'true') return;
    // reach the maximum number of times the popup has been closed, don't show the popup
    const closedCount = Number(localStorage.getItem('smsPopupClosedCount'));
    if (closedCount >= Number(closedCountMax)) return;
    // If the popup is for returned user, don't show it unless the current user is a returned customer
    if (isForReturnedUser && !isReturnedUser) return;
    // If the popup is for new user, don't show it for returned customer
    if (!isForReturnedUser && isReturnedUser && window.Shopify.isReturnedUserPopupActive) return;
    // If the user closed the popup before, don't show it within Y days
    // const daysDiff = Math.floor((new Date().getTime() - Number(localStorage.getItem('smsPopupClosedTime'))) / 86400000);
    // if (closedCount > 0 && daysDiff <= Number(daysNotToShow)) return;

    // otherwise, show the popup after X second
    setTimeout(() => {
      setShow(true);
    }, Number(secsToPopup) * 1000);
  }, [secsToPopup, daysNotToShow, closedCountMax, prefix, isForReturnedUser, isReturnedUser]);

  const onClose = () => {
    setShow(false);
    // Don't do anything if the popup is closed after sign up this week's promo
    if (localStorage.getItem(`${prefix}SignedUp`) === 'true') return;
    // Closed for the rest of this week's promo
    localStorage.setItem(`${prefix}SignUpClosed`, 'true');
    // Record the closed timestamp
    // localStorage.setItem('smsPopupClosedTime', `${new Date().getTime()}`);
    // Increment the closed count
    const closedCount = Number(localStorage.getItem('smsPopupClosedCount'));
    localStorage.setItem('smsPopupClosedCount', `${closedCount + 1}`);
  };

  const handleSignedUp = () => {
    setHasSignedUp(true);
    localStorage.setItem('smsPopupSignedUp', 'true');
    localStorage.setItem(`${prefix}SignedUp`, 'true');
  };

  return (
    <Modal show={show} onClose={onClose} isFixedSize>
      <PopupModalContent
        heroImage={popupHero}
        source="signup_popup"
        hasSignedUp={hasSignedUp}
        heading={popupHeading}
        giftImage={giftImage}
        desc={popupContent}
        onSubmitSuccess={handleSignedUp}
      />
    </Modal>
  );
};

PopupSignUp.propTypes = {
  campaignId: PropTypes.string.isRequired,
  giftImage: PropTypes.string,
  popupHero: PropTypes.string.isRequired,
  popupHeading: PropTypes.string.isRequired,
  popupContent: PropTypes.string.isRequired,
  secsToPopup: PropTypes.string.isRequired,
  daysNotToShow: PropTypes.string.isRequired,
  closedCountMax: PropTypes.string.isRequired,
  isForReturnedUser: PropTypes.bool,
};

PopupSignUp.defaultProps = {
  giftImage: null,
  isForReturnedUser: false,
};

export { PopupSignUp };
